import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";
import { standardReducer } from "@/store/utils.js";

const salesReducer = createAsyncReducer({
  name: 'sales',
  initialState: {
    records: {},
    loading: false,
    errorMessage: ''
  },
  reducers: (create) => ({
    update: create.asyncThunk(
      async ({ id, ...attributes }) => {
        return Fetch.patch(Routes.ajax_sale_path(id), {
          body: attributes
        });
      },
      standardReducer,
    ),
    loadOne: create.asyncThunk(
      async ({ id }) => {
        return Fetch.get(Routes.ajax_sale_path(id));
      },
      standardReducer
    )
  })
});

export default salesReducer;